import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onBeforeUnmount, onMounted } from 'vue'
import store from '@/store/store'
import WidgetBaseComponent from '@/components/widgets/WidgetBaseComponent.vue'
import { Icons } from '@/icons/icons'
import { ContextName, ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'
import PhoneListComponent from '@/components/widgets/ExpedientWidgets/ExpedientSummaryWidget/PhoneListComponent.vue'
import PhoneListTooltip from '@/components/widgets/ExpedientWidgets/ExpedientSummaryWidget/PhoneListTooltip.vue'
import useSelectedRegister from '@/composables/useSelectedRegister'
import useStage from '@/composables/useStage'
import useEntity from '@/composables/useEntity'
import useEndpoints from '@/composables/useEndpoints'
import useTruncation from '@/composables/useTruncation'

// CONSTANTS

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpedientSummaryWidget',
  setup(__props) {

const selectedRegisterModule = ModuleNamespaces.SELECTED_REGISTER

const icon = {
  bill: Icons.BILL,
  clock: Icons.CLOCK,
  money: Icons.BILLING,
  tooltip: Icons.INFO_FULL
}

const contexts = {
  expedientSummary: ContextName.EXPEDIENT_SUMMARY_WIDGET,
  expedientContext: ContextName.EXPEDIENTS
}

// DATA
const showSpinner = ref(true)

// COMPUTED
const expedientStageStateGetter = computed(() => expedientStage.value)

const expedientSummaryData = computed(() => {
  return selectedRegisterData.value?.globalVisionExpSummary || { body: [], counters: [] }
})

const infoItems = computed(() => {
  if (!expedientSummaryData.value) return []
  return expedientSummaryData.value.body
})

const allDataLoaded = computed(() => {
  if (!expedientSummaryData.value) return false
  return !!(expedientSummaryData.value && Object.keys(expedientSummaryData.value).length)
})

const parseResumeCounters = computed(() => {
  if (!expedientSummaryData.value) return []
  return expedientSummaryData.value.counters.map((item: any) => ({
    title: item.label,
    qty: item.data,
    message: item.tooltip || ''
  }))
})

// COMPOSABLES
const expedientRegister = useSelectedRegister({ entityName: contexts.expedientContext })
const summaryInfo = useSelectedRegister({ entityName: contexts.expedientSummary })

const { selectedRegisterId: selectedExpedientId, loadSelectedRegisterWithPost } = expedientRegister
const { selectedRegisterData } = summaryInfo

const { expedientStage } = useStage()
const { getEntity } = useEntity({ entityName: contexts.expedientContext })
const { getEndpoints } = useEndpoints()

const { isTruncatedItems, checkTruncation, setRef } = useTruncation({
  items: infoItems,
  debounceTime: 0
})

// METHODS
const fetchSummaryInfo = async () => {
  showSpinner.value = true

  const entity = getEntity()
  const entityType = entity.type
  const endpoints = getEndpoints(entityType)
  const endpoint = endpoints.get

  await loadSelectedRegisterWithPost({
    endpoint,
    context: contexts.expedientSummary,
    post: {
      idExpedient: selectedExpedientId.value,
      source: contexts.expedientSummary,
      idStage: expedientStageStateGetter.value
    }
  })

  showSpinner.value = false
}

const renderIcon = (index: number) => {
  switch (index) {
    case 0:
      return icon.clock
    case 1:
      return icon.bill
    default:
      return icon.money
  }
}

// WATCHERS
watch(expedientStageStateGetter, () => {
  fetchSummaryInfo()
})

// HOOKS
onMounted(async () => {
  await fetchSummaryInfo()
})

onBeforeUnmount(() => {
  store.commit(`${selectedRegisterModule}/REMOVE_SELECTED_REGISTER_DATA_CONTEXT`, contexts.expedientSummary)
})

return { __sfc: true,selectedRegisterModule, icon, contexts, showSpinner, expedientStageStateGetter, expedientSummaryData, infoItems, allDataLoaded, parseResumeCounters, expedientRegister, summaryInfo, selectedExpedientId, loadSelectedRegisterWithPost, selectedRegisterData, expedientStage, getEntity, getEndpoints, isTruncatedItems, checkTruncation, setRef, fetchSummaryInfo, renderIcon, WidgetBaseComponent, LexonTooltipComponent, PhoneListComponent, PhoneListTooltip }
}

})